import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-[#0a0a0a] pt-24 pb-16 px-4 md:pt-32 md:pb-24 overflow-hidden relative" data-id="element-63">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-indigo-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-64" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-65">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-66">
          Cómo Construir un Sistema de Monetización Directa de{' '}
          <span className="text-green-400" data-id="element-67">$2,000 USD al Mes</span> en solo 30
          Días Sin Necesidad de Ser Viral, Tener 50k Seguidores, ni Depender de
          Marcas que Pagan Poco.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-400 italic mb-10 max-w-3xl mx-auto" data-id="element-68">
          — Incluso si hoy sientes que el algoritmo de Instagram te odia y tus
          ventas están en cero.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-base md:text-lg text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-69">
          Deja de ser un "creador de contenido" que regala su tiempo a Meta y
          conviértete en el dueño de un negocio digital rentable.{' '}
          <strong data-id="element-70">Creator OS v2026</strong> es el mapa exacto para creadores en
          Latam que quieren libertad, no solo likes.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mb-12 relative" data-id="element-71">
          <div className="absolute inset-0 bg-indigo-500/20 blur-3xl rounded-full" data-id="element-72" />
          <img src="https://cdn.magicpatterns.com/uploads/f4QtuejcXt8WFg2Ejt6ES8/heylloyd-image-1772920040382.png" alt="Creator OS v2026 Dashboard" className="w-full max-w-3xl mx-auto rounded-2xl shadow-[0_0_40px_rgba(99,102,241,0.3)] relative z-10 border border-white/10" data-id="element-73" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-74">
          <CTAButton onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-75">
            SÍ, QUIERO EL SISTEMA AHORA
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}